import React, { useMemo } from "react";
import { FileDownload } from "@mui/icons-material";

import { useCustomWorkflow } from "fond/hooks/useCustomWorkflow";
import { Project, WORKFLOW_KEYS } from "fond/types";
import { AccordionStepper, AccordionStepperPane, StackedNavigationButton, useStackedNavigationContext } from "fond/widgets";

import ServiceAreaPanel from "./ServiceAreaPanel";

interface ArtefactsPanelProps {
  project: Project;
  versionId: string;
  readOnly: boolean;
}

const ArtefactsPanel: React.FC<ArtefactsPanelProps> = ({ project, versionId, readOnly }: ArtefactsPanelProps) => {
  const { workflowState } = useCustomWorkflow({ versionId, key: WORKFLOW_KEYS.PLANNER_EXTENDED.SERVICE_AREA });
  const { open } = useStackedNavigationContext();

  const accordionPanes: AccordionStepperPane[] = useMemo(
    () => [
      {
        header: "Service Area",
        id: "service-area",
        content: <ServiceAreaPanel project={project} versionId={versionId} readOnly={readOnly} />,
        isComplete: workflowState === "COMPLETE",
      },
    ],
    [project, readOnly, versionId, workflowState]
  );

  return (
    <>
      <AccordionStepper id={`${project.ID}-artefacts`} panes={accordionPanes} autoMove={[""]} variant="outlined" />
      <StackedNavigationButton
        data-testid="export-construction-prints-button"
        icon={<FileDownload />}
        title="Construction prints"
        subtitle="Export construction prints"
        sx={{ m: 0 }}
        onClick={() => open("construction-prints-export")}
      />
    </>
  );
};

export default ArtefactsPanel;
